

import ProductModal from "../home/modals/product.modal.jsx";

export default function Product() {
  return (
    <article className="product">
      <ProductModal />
    </article>
  );
}
